import { Box, Button, Grid, Table, TableBody, TableHead, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { institutionSelector } from "../../../../store/researchauthoritiesSlice";
import StyledTableCell from "../../Components/Tables/StyledTableCell";
import StyledTableRow from "../../Components/Tables/StyledTableRow";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import service from "../../Helpers/gifservices";
import Note from "../../Components/applicants/Note";
import { grantStatus } from "../../Constants";
import { useLoading } from "../../../../providers/loadingProvider";

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    marginLeft: 5,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom:10,
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
}));

export default function PreGrantees() {
  const classes = useStyles();
  const loading = useLoading(); 
  const institution = useSelector(institutionSelector);
  const [preGrants, setPreGrants] = useState([]);
  const tableHeaders = [
    { label: "View Applicantion", width: "15%" },
    { label: "Name", width: "20%" },
    { label: "Grant Number", width: "20%" },
    { label: "Email", width: "30%" },
    { label: "Note", width: "15%" },
  ];

  const createPDF = async (proposalId, proposalNumber) => {
    if (!Boolean(proposalId)) return;
    const loadingId = loading.addLoading("Downloading Proposal Info..");
    const pdfPath = await service.createProposalPDF({ proposalId });
    await service.downloadRawFile({
      path: pdfPath,
      filename: proposalNumber,
    });
    loading.removeLoading(loadingId);
  };

  const UpdateGrantNote = async (grantId, note) => {
    const loadingId = loading.addLoading("Updating Note");
    await service.UpdateGrantRAnote({ grantId, note });
    loading.removeLoading(loadingId);
  };

  const getGtants = useCallback(async () => {
    const loadingId = loading.addLoading("Loading Pre Grants");
    const grantStatusList = [grantStatus.preGrant];
    var preGrants = await service.GetApplicantsGrantees({
      institutionId: institution.id,
      grantStatusList,
    });
    setPreGrants(preGrants);
    loading.removeLoading(loadingId);
  }, [institution.id, loading]);

  useEffect(() => {
    getGtants();
  }, [getGtants]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box className={classes.header}>
          <Typography variant="subtitle2">Pre Grants</Typography>
          <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
        </Box>
      </Grid>
      <Table className={classes.table}>
        <TableHead>
          <StyledTableRow>
            {tableHeaders.map((header) => (
              <StyledTableCell
                key={header.label}
                style={{ width: header.width }}
              >
                {header.label}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {preGrants.map((preGrant, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>
                <Button
                  startIcon={<PictureAsPdfRoundedIcon />}
                  className={classes.button}
                  onClick={()=>createPDF(preGrant.applicant.proposalfullnumber, preGrant.applicant.proposalName)}
                >
                  View PDF
                </Button>
              </StyledTableCell>
              <StyledTableCell>
                {`${preGrant.applicantFirstName} ${preGrant.applicantLastName}`}
              </StyledTableCell>
              <StyledTableCell>
              {preGrant.grantNumber}
              </StyledTableCell>
              <StyledTableCell>{`${preGrant.emailadress}`}</StyledTableCell>
              <StyledTableCell>
              <Note text={preGrant.notesFromRA}  onSave={(note)=>UpdateGrantNote(preGrant.grantId, note)}/>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
}
